/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable no-dupe-keys */
import React, { useState, useRef, useEffect } from "react";
import Head from "../../layout/head/Head";
import Content from "../../layout/content/Content";
import {
  Button,
  Block,
  BlockDes,
  BlockHead,
  Icon,
  Col,
  Row,
} from "../../components/Component";
import OptionM from "../components/DynmicOption/OptionM";
import OptionC from "../components/DynmicOption/OptionC";
import CenterOption from "../components/DynmicOption/CenterOption";
import { Spinner } from "reactstrap";
import { DownloadTableExcel } from "react-export-table-to-excel";
import "./style.css";

const ReportNew = ({ ...props }) => {
  const [Statee, setStatee] = useState([]);
  const [loading, setLoading] = useState(false);
  //const [tableReady, setTableReady] = useState(false);
  const [error, setError] = useState(null);
  const month1 = [
    "Test",
    "JANUARY",
    "FEBRUARY",
    "MARCH",
    "APRIL",
    "MAY",
    "JUNE",
    "JULY",
    "AUGUST",
    "SEPTEMBER",
    "OCTOBER",
    "NOVEMBER",
    "DECEMBER",
  ];

  const today = new Date();
  const tableRef = useRef(null);
  const [formData, setFormData] = useState({
    month: sessionStorage.getItem("CurrentMonth") || (today.getMonth() === 0 ? 12 : today.getMonth()),
    dummymonth:
      month1[sessionStorage.getItem("CurrentMonth") || today.getMonth()],
    year: sessionStorage.getItem("CurrentYear") || (today.getMonth() === 0 ? today.getFullYear() -1  : today.getFullYear()),
    tomonth: sessionStorage.getItem("CurrentMonth2") || (today.getMonth() === 0 ? 12 : today.getMonth()),
    todummymonth:
      month1[sessionStorage.getItem("CurrentMonth2") || today.getMonth()],
    toyear: sessionStorage.getItem("CurrentYear2") || (today.getMonth() === 0 ? today.getFullYear() -1  : today.getFullYear()),
    EmploymentRefId: 10,
    state: 0,
    generate: 0,
    CenterId: 0,
  });

  const [centergen, setCntergen] = useState(false);
  const [generate1, setGenerate1] = useState(false);
  const [selectcenter, setSelectcenter] = useState(false);

  const getData = async () => {
    setLoading(true);
    setError(null);
    const sendData = {
      YearId: Number(formData.year),
      MonthId: Number(formData.month),
      ToYearId: Number(formData.toyear),
      ToMonthId: Number(formData.tomonth),
      UserId: Number(formData.CenterId),
    };
    console.log("SendData: ", sendData);

    try {
      const response = await fetch(
        process.env.REACT_APP_API_LINK + "api/NCSCDA/MainReport",
        {
          method: "POST",
          headers: {
            Accept: "application/json",
            "Content-Type": "application/json",
          },
          body: JSON.stringify(sendData),
        }
      );

      if (!response.ok) {
        throw new Error("Failed to fetch data");
      }

      const data = await response.json();
      setStatee(data);
    } catch (err) {
      setError("Error loading data. Please try again later.");
      console.error("Fetch error:", err);
    } finally {
      setLoading(false);
    }
  };

  const transpose = (matrix) => {
    return matrix[0].map((_, colIndex) => matrix.map((row) => row[colIndex]));
  };
  // Convert dataset object into a matrix for transposing

  const createMatrix = (data) => {
    const stateDescriptions = {
      stateName: "DESCRIPTION",
      intake: "Intake",
      evaluation: "Evaluation",
      rehabilitation: "Rehabilitation",
      wagePaidEmployment: "Wage Paid Employment",
      trainingatCentre: "Training at Centre",
      trainingOthers: "Training Others",
      selfEmployments: "Self Employments",
      physicalRestoration:
        "Physical Restoration (Aids and Appliances distributed)",
      numberofEvents:
        "Number of Events Organized for Distribution of Tool Kits and Aids and Appliances",
      submission: "Submission (Sponsored)",
      followUpswithPwDs: "Follow Ups with PwDs",
      liveRegisterattheend: "Live Register(LR) at the end of the month",
      traineesonroll:
        "No. of trainees on roll at the end of month ( trade wise)",
      noofCampsOrganised: "No. of Camps Organised",
      jobFairs: "Job Fairs",
      noofJobseekersParticipated: "No. of Job-seekers Participated",
      noofEmployersParticipated: "No. of Employers Participated",
      noofCandidatesParticipated: "No. of Candidates Shortlisted",
    };

    const headers = Object.keys(data[0] || {});

    // Replace state names with descriptions in the headers
    const modifiedHeaders = headers.map(
      (header) => stateDescriptions[header] || header
    );

    const values = data.map(Object.values);

    // Return the matrix with modified headers
    return [modifiedHeaders, ...values];
  };

  const transposedData = transpose(createMatrix(Statee));

  useEffect(() => {
    if (generate1) {
      getData();
    }
  }, [generate1, formData]);

  const onInputChange = (month, year) => {
    setCntergen(false);

    setFormData({ ...formData, month, year });
  };
  const onInputChange2 = (tomonth, toyear) => {
    setCntergen(false);
    setFormData({ ...formData, tomonth, toyear });
  };
  const onInputChangeCenter = (e) => {
    setCntergen(false);
    setSelectcenter(false);
    setFormData({ ...formData, CenterId: e.target.value });
  };

  const generate = async () => {
    setCntergen(true);
    setGenerate1(true);
    if (formData.CenterId === 0) {
      setSelectcenter(true);
    }
  };

  //const setTableRef = useCallback((node) => {
  //  if (node) {
  //      tableRef.current = node;
  //      setTableReady(true)
  //    //console.log("TableRef is ready:", tableRef.current);
  //  }
  //}, []);

  return (
    <React.Fragment>
      <Head title="Main Report" />
      <Content>
        <Block>
          <BlockHead size="lg">
            <BlockDes className="text-soft">
              <Row>
                <Col xl="3" md="3">
                  <h5 style={{ color: "#798bff" }}>DA Dashboard</h5>
                </Col>
                <Col xl="3" md="3">
                  <label style={{ color: "black", fontSize: 14 }}>
                    Center:{" "}
                    <label style={{ fontWeight: "bold" }}>
                      <CenterOption
                        defaultValuemain={formData.CenterId}
                        catid="42"
                        onInputChange={onInputChangeCenter}
                        namemain="year"
                        mainid="year"
                      />
                    </label>
                  </label>
                </Col>
                <Col xl="3" md="3">
                  <label style={{ color: "black", fontSize: 12 }}>
                    From:{" "}
                    <label style={{ fontWeight: "bold" }}>
                      <OptionC
                        defaultValuemain={formData.year}
                        catid="42"
                        onInputChange={onInputChange}
                        namemain="year"
                        mainid="year"
                      />
                    </label>
                  </label>
                </Col>
                <Col xl="3" md="3">
                  <label style={{ color: "black", fontSize: 13 }}>
                    To:{" "}
                    <label style={{ fontWeight: "bold" }}>
                      <OptionM
                        onInputChange={onInputChange2}
                        year={formData.year}
                        month={formData.month}
                        tomonth={formData.tomonth}
                        toyear={formData.toyear}
                      />
                    </label>
                  </label>
                </Col>
                {centergen === false && (
                  <Col xl="3" md="3">
                    <Button
                      color="success"
                      style={{ marginTop: 10 }}
                      onClick={generate}
                    >
                      Generate
                    </Button>
                  </Col>
                )}
              </Row>
            </BlockDes>
          </BlockHead>
          <hr />

          {/*hidden table*/}

          {Statee.length > 0 && (
            <table
              className="table table-orders"
              ref={tableRef}
              style={{
                borderCollapse: "separate",
                borderSpacing: 0,
                border: "1px solid black",
                display: "none",
              }}
            >
              <thead
                style={{
                  position: "sticky",
                  top: 0,
                  backgroundColor: "#edecec",
                }}
              >
                {/* Form Details Row */}
                <tr className="export-only">
                  <th colSpan="3" style={tableHeaderStyle}>
                    Form: Main Report
                  </th>
                  <th
                    colSpan="3"
                    style={{
                      textAlign: "center",
                      border: "3px solid black",
                      color: "black",
                      backgroundColor: "orange",
                      padding: 10,
                      verticalAlign: "inherit",
                    }}
                  >
                    From Date: {month1[formData.month]} {formData.year}
                  </th>
                  <th
                    colSpan="3"
                    style={{
                      textAlign: "center",
                      border: "3px solid black",
                      color: "black",
                      backgroundColor: "orange",
                      padding: 10,
                      verticalAlign: "inherit",
                    }}
                  >
                    To Date: {month1[formData.tomonth]} {formData.toyear}
                  </th>
                </tr>

                {/* Progress Report Title Row */}
                <tr className="table-header">
                  <th
                    colSpan={Statee.length + 1}
                    className="table-header"
                    style={tableHeaderStyle}
                  >
                    PROGRESS REPORT OF NATIONAL CAREER SERVICE CENTRES FOR
                    DIFFERENTLY ABLED
                  </th>
                  {selectcenter && (
                    <th
                      rowSpan="2"
                      className="table-header"
                      style={tableHeaderStyle}
                    >
                      Grand Total
                    </th>
                  )}
                </tr>

                {/* Dynamic Headers Row */}
                <tr>
                  {transposedData[0].map((header, index) => (
                    <th key={index} style={tableHeaderStyle}>
                      {header}
                    </th>
                  ))}
                </tr>
              </thead>

              <tbody>
                {transposedData.slice(1).map((row, rowIndex) => (
                  <tr key={rowIndex}>
                    {row.map((cell, cellIndex) => (
                      <th
                        key={cellIndex}
                        style={
                          cellIndex === 0
                            ? {
                                textAlign: "center",
                                border: "1px solid black",
                                padding: 10,
                                fontWeight: "bold",
                                verticalAlign: "inherit",
                                backgroundColor: "#eaf8dd",
                                color: "black",
                                maxWidth: 150,
                              }
                            : {
                                textAlign: "center",
                                border: "1px solid black",
                                padding: 10,
                              }
                        }
                      >
                        {cell || 0}
                      </th>
                    ))}
                    {/* Add a new cell to display the sum */}
                    {selectcenter && (
                      <th
                        style={{
                          textAlign: "center",
                          border: "1px solid black",
                          padding: 10,
                          fontWeight: "bold", // Optional styling
                        }}
                      >
                        {row
                          .slice(1)
                          .reduce(
                            (sum, cell) =>
                              sum + (isNaN(cell) ? 0 : Number(cell)),
                            0
                          )}
                      </th>
                    )}
                  </tr>
                ))}
              </tbody>
            </table>
          )}

          {generate1 ? (
            centergen === true ? (
              <>
                <Row>
                  <Col md="2" lg="3"></Col>
                  <Col md="2" lg="3"></Col>
                  <Col md="2" lg="3"></Col>
                  {!loading && (
                    <Col md="2" lg="3">
                      {!loading && Statee.length > 0 && (
                        <DownloadTableExcel
                          filename={`Main Report (${month1[formData.month]}-${
                            formData.year
                          } to ${month1[formData.tomonth]}-${formData.toyear})`}
                          sheet="Report Data"
                          currentTableRef={tableRef.current}
                        >
                          <Button
                            style={{ float: "right", marginBottom: 10 }}
                            color="info"
                            onClick={() => console.log(tableRef.current)}
                          >
                            <Icon className="icon ni ni-download" />
                            Export Excel
                          </Button>
                        </DownloadTableExcel>
                      )}
                    </Col>
                  )}
                </Row>

                {loading ? (
                  <div>
                    <h3
                      style={{
                        display: "flex",
                        justifyContent: "center",
                        alignItems: "center",
                      }}
                    >
                      Please wait while the report is loading......
                    </h3>
                    <br />
                    <div
                      style={{
                        display: "flex",
                        justifyContent: "center",
                        alignItems: "center",
                      }}
                    >
                      <Spinner size="xl" />
                    </div>
                  </div>
                ) : error ? (
                  <h3>{error}</h3>
                ) : Statee.length === 0 ? (
                  <h3>No Data Available for Selected Months</h3>
                ) : (
                  <div
                    style={{
                      height: window.innerHeight - 100,
                      width: "auto",
                      overflow: "scroll",
                    }}
                    className="table-responsive"
                  >
                    <table
                      className="table table-orders"
                      style={{
                        borderCollapse: "separate",
                        borderSpacing: 0,
                        border: "1px solid black",
                      }}
                    >
                      <thead
                        style={{
                          position: "sticky",
                          top: 0,
                          backgroundColor: "#edecec",
                        }}
                      >
                        {/* Form Details Row */}
                        <tr className="export-only">
                          <th colSpan="3" style={tableHeaderStyle}>
                            Form: Main Report
                          </th>
                          <th
                            colSpan="3"
                            style={{
                              textAlign: "center",
                              border: "3px solid black",
                              color: "black",
                              backgroundColor: "orange",
                              padding: 10,
                              verticalAlign: "inherit",
                            }}
                          >
                            From Date: {month1[formData.month]} {formData.year}
                          </th>
                          <th
                            colSpan="3"
                            style={{
                              textAlign: "center",
                              border: "3px solid black",
                              color: "black",
                              backgroundColor: "orange",
                              padding: 10,
                              verticalAlign: "inherit",
                            }}
                          >
                            To Date: {month1[formData.tomonth]}{" "}
                            {formData.toyear}
                          </th>
                        </tr>

                        {/* Progress Report Title Row */}
                        <tr className="table-header">
                          <th
                            colSpan={Statee.length + 1}
                            className="table-header"
                            style={tableHeaderStyle}
                          >
                            PROGRESS REPORT OF NATIONAL CAREER SERVICE CENTRES
                            FOR DIFFERENTLY ABLED
                          </th>
                          {selectcenter && (
                            <th
                              rowSpan="2"
                              className="table-header"
                              style={tableHeaderStyle}
                            >
                              Grand Total
                            </th>
                          )}
                        </tr>

                        {/* Dynamic Headers Row */}
                        <tr>
                          {transposedData[0].map((header, index) => (
                            <th key={index} style={tableHeaderStyle}>
                              {header}
                            </th>
                          ))}
                        </tr>
                      </thead>

                      <tbody>
                        {transposedData.slice(1).map((row, rowIndex) => (
                          <tr key={rowIndex}>
                            {row.map((cell, cellIndex) => (
                              <th
                                key={cellIndex}
                                style={
                                  cellIndex === 0
                                    ? {
                                        textAlign: "center",
                                        border: "1px solid black",
                                        padding: 10,
                                        fontWeight: "bold",
                                        verticalAlign: "inherit",
                                        backgroundColor: "#eaf8dd",
                                        color: "black",
                                        maxWidth: 150,
                                      }
                                    : {
                                        textAlign: "center",
                                        border: "1px solid black",
                                        padding: 10,
                                      }
                                }
                              >
                                {cell || 0}
                              </th>
                            ))}
                            {/* Add a new cell to display the sum */}
                            {selectcenter && (
                              <th
                                style={{
                                  textAlign: "center",
                                  border: "1px solid black",
                                  padding: 10,
                                  fontWeight: "bold", // Optional styling
                                }}
                              >
                                {row
                                  .slice(1)
                                  .reduce(
                                    (sum, cell) =>
                                      sum + (isNaN(cell) ? 0 : Number(cell)),
                                    0
                                  )}
                              </th>
                            )}
                          </tr>
                        ))}
                      </tbody>
                    </table>
                  </div>
                )}
              </>
            ) : (
              <h3>Please Click On Generate Button for Report!</h3>
            )
          ) : (
            <h3>Please Select Month and Year to Generate Report!</h3>
          )}
        </Block>
      </Content>
    </React.Fragment>
  );
};

const tableHeaderStyle = {
  textAlign: "center",
  border: "1px solid black",
  color: "black",
  backgroundColor: "orange",
  padding: 10,
  verticalAlign: "inherit",
};

export default ReportNew;
